import app from 'flarum/common/app';
import UserGroupsWidget from '../forum/components/UserGroupsWidget';

export default function RegisterWidget() {
  if (app.widgets && app.widgets.add) {
    app.widgets.add({
      key: 'user-groups',
      component: UserGroupsWidget,
      isDisabled: false,
      isUnique: true,
      placement: 'start_top',
      position: 1
    }, 'tf-groups');
  }
}

